import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import TitleWrapper from "../../../components/ui/titlewrapper/TitleWrapper";
import AdditionalAddOns from "../component/Pricing/component/AdditionalAddOns";
import PricingDetails from "../component/Pricing/component/PricingDetails";

const initState = {
  isAttandance: 'There is a cost to attend',
};

export const PricingData = {
  name: "EditMembershipTaskListFormData",
  initialState: initState,
  section: [
    {
      title: "Pricing Section",
      row: {},
      style: {
        sectionStyle: "verticle-form mb-3 form-card row",
      },

      wrapperTemplate: <TitleWrapper title="Pricing" />,

      fields: [
        {
          id: "isAttandance",
          label: "",
          Field_Name: "Attandance",
          fieldType: FormFieldTypes.RADIOBUTTON,
          dataField: "isAttandance",
          fieldSetting: {
            allowSpace: true,
            options: [
              { value: "Attendance is free", label: "Attendance is free" },
              {
                value: "There is a cost to attend",
                label: "There is a cost to attend",
              },
            ],
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 radioStyle col-md-4 ",
          },
        },
      ],
    },
    // {
    //   title: "Pricing Details Section",
    //   row: {},
    //   style: {
    //     sectionStyle: "verticle-form mb-3 form-card row",
    //   },

    //   wrapperTemplate: (
    //     <TitleWrapper title="Pricing Details (Enter Price Excluding GST)" />
    //   ),

    //   fields: [{
    //     id: "",
    //     label: "",
    //     Field_Name: "",
    //     fieldType: FormFieldTypes.MAINFORMTITLE,
    //     dataField: "",
    //     fieldSetting: {
    //       isFormControl: true,
    //       formControltemplate: <PricingDetails />,
    //     },
    //   }],
    // },
    // {
    //   title: "Additional Guest/Attendee Section",
    //   row: {},
    //   style: {
    //     sectionStyle: "verticle-form mb-3 form-card row",
    //   },

    //   wrapperTemplate: <TitleWrapper title="Additional Guest/Attendee" />,

    //   fields: [
    //     {
    //       id: "maxGuest",
    //       label: "Max guest",
    //       Field_Name: "Max guest",
    //       fieldType: FormFieldTypes.SELECT,
    //       dataField: "maxGuest",
    //       fieldSetting: {
    //         placeholder: "Select",
    //         allowSpace: true,
    //         options: [
    //           { value: 0, label: '0' },
    //           { value: 1, label: '1' },
    //           { value: 2, label: '2' },
    //           { value: 3, label: '3' },
    //           { value: 4, label: '4' },
    //           { value: 5, label: '5' },
    //           { value: 999, label: 'No Limit' },
    //         ],
    //       },
    //       // validation: [{ type: validationTypes.REQUIRE }],
    //       style: {
    //         containerCss: "col-lg-4 col-md-4 validation-left-0",
    //       },
    //     },
    //     {
    //       id: "isQuantityAllow",
    //       label: "Quantity Allow",
    //       Field_Name: "Quantity Allow",
    //       fieldType: FormFieldTypes.CHECKBOX,
    //       dataField: "isQuantityAllow",
    //       fieldSetting: {
    //       },
    //       style: {
    //         containerCss: "col-lg-6 col-md-6 radioStyle  mb-2 mt-4",
    //       },
    //     },
    //   ],
    // },

  ],
  formSetting: {
    // isViewOnly: false,
  },
};


export const AdditionalGuestSectionData = {
  name: "Additional Guest/Attendee Section",
  initialState: { maxGuest: '', isQuantityAllow: false },
  section: [
    {
      title: "Additional Guest/Attendee Section",
      row: {},
      style: {
        sectionStyle: "verticle-form mb-3 form-card row",
      },

      wrapperTemplate: <TitleWrapper title="Additional Guest/Attendee" />,

      fields: [
        {
          id: "maxGuest",
          label: "Max guest",
          Field_Name: "Max guest",
          fieldType: FormFieldTypes.SELECT,
          dataField: "maxGuest",
          fieldSetting: {
            placeholder: "Select",
            allowSpace: true,
            options: [
              { value: 0, label: '0' },
              { value: 1, label: '1' },
              { value: 2, label: '2' },
              { value: 3, label: '3' },
              { value: 4, label: '4' },
              { value: 5, label: '5' },
              { value: 15, label: 'No Limit' },
            ],

            isDisable: initState.isQuantityAllow === true
          },
          // validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-4 validation-left-0",
          },
        },
        {
          id: "isQuantityAllow",
          label: "Quantity Allow",
          Field_Name: "Quantity Allow",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isQuantityAllow",
          fieldSetting: {
          },
          style: {
            containerCss: "col-lg-6 col-md-6 radioStyle  mb-2 mt-4",
          },
        },
      ],
    },

  ],
  formSetting: {
    // isViewOnly: false,
  },
};

export const AdditionalAddOnsSectionData = {
  name: "Additional Add-Ons Section",
  initialState: { isAdditionalAddOns: "No additional fee" },
  section: [
    {
      title: "Additional Add-Ons Section",
      row: {},
      style: {
        sectionStyle: "verticle-form mb-3 form-card row",
      },
      wrapperTemplate: <TitleWrapper title="Additional Add-Ons" />,

      fields: [
        {
          id: "isAdditionalAddOns",
          label: "",
          Field_Name: "Additional Add-Ons",
          fieldType: FormFieldTypes.RADIOBUTTON,
          dataField: "isAdditionalAddOns",
          fieldSetting: {
            allowSpace: true,
            options: [
              { value: "No additional fee", label: "No additional fee" },
              { value: "There is additional fee", label: "There is additional fee", },
            ],
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 radioStyle col-md-4 mb-3",
          },
        },
      ],
    },
  ],
  formSetting: {
    // isViewOnly: false,
  },
};
